
import ProfileComponent from "@/components/pages/Profile";
import { Layout } from "@/components/layout/Layout";
import { SidebarProvider } from "@/context/SidebarContext";

const Profile = () => {
  return (
    <SidebarProvider>
      <Layout />
    </SidebarProvider>
  );
};

export default Profile;
